// extracted by mini-css-extract-plugin
export default {"modal":"Popup_modal__-BTgq","active":"Popup_active__vTe8E","modalContent":"Popup_modalContent__X1UQr","iconClose":"Popup_iconClose__-ZsS6","close":"Popup_close__E9qza"};